import SchedulingReports from './SchedulingReportsContainer';

export default SchedulingReports;



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/SchedulingReports/index.js